export default "__VITE_ASSET__BGPcTKYr__"